<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('integracao-endereco-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'integracao-endereco-create'}"
                    color="primary"
                >
                    Cadastrar integração de endereço
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/integracao/endereco/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>